/* eslint-disable react/jsx-no-useless-fragment */
import { useGeoIp } from '@srcDS/js/hooks/useGeoIp';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import clsx from 'clsx';
import { NoticesProvider } from 'apgdev/src/js/provider/notices/NoticesProvider';
import PrimaryLoader from '@srcDS/js/components/atoms/primaryLoader/PrimaryLoader';
import { CartProvider } from 'apgdev/src/js/provider/cart/CartProvider';
import { GlobalProvider } from 'apgdev/src/js/provider/global/GlobalProvider';
import { WishlistProvider } from 'apgdev/src/js/provider/wishlist/WishlistProvider';
import { LayoutProvider } from 'apgdev/src/js/provider/layout/LayoutProvider';
import { useFixRerenderOnMobile } from '@srcDS/js/utils/useFixRerenderOnMobile';
import { NostoProvider } from 'apgdev/src/js/provider/nosto/NostoProvider';
import { MenuProvider } from 'apgdev/src/js/provider/menu/MenuProvider';
import { PreconnectLinks } from 'apgdev/src/js/utils/PreconnectLinks';
import ZendeskWidget from 'apgdev/src/js/components/atoms/zendesk/webWidget';
import { ReCaptchaProvider } from 'apgdev/src/js/provider/reCaptcha/ReCaptchaProvider';
import { useNostoContext } from '@apgnext/frontend/legacy/js/provider/nosto/NostoContext';
import styles from './SportscraftAppWrapper.module.scss';

const AppWrapper = ({ children, node }) => {
  const { getSearchSessionParams, hasNostoJs, hasNostoSessionParams } = useNostoContext();

  useEffect(() => {
    if (hasNostoJs) {
      getSearchSessionParams();
    }
  }, [hasNostoJs, hasNostoSessionParams]);
  return (
    <div id="bodyWrapper" className={clsx(styles.bodyWrapper, '_vwo_scroll_fix')}>
      <PreconnectLinks />
      {node.loading && <PrimaryLoader />}
      {children}
      <ZendeskWidget />
    </div>
  );
};

const SportscraftAppWrapper = ({ children, renderContext, node, appState, context }) => {
  const { setGeoIp } = useGeoIp();
  const hideBlock = () => {
    const errEl = document.getElementById('frssrw');
    errEl?.setAttribute('style', 'display: none;');
  };

  useEffect(() => {
    if (!renderContext.serverSideRendering) {
      localStorage.removeItem('searchedValue');
      localStorage.setItem('brand', 'Sportscraft');
    }
    return () => false;
  }, [renderContext]);

  // Update to get geolocation only one on page load and not on every state update
  useEffect(() => {
    setGeoIp();
    hideBlock();
    useFixRerenderOnMobile();
  }, []);

  return (
    <ReCaptchaProvider reCaptchaKey={context?.project?.configuration?.gRecaptcha?.sitekey}>
      <GlobalProvider>
        <LayoutProvider globalNodeLoading={node?.loading}>
          <NoticesProvider>
            <WishlistProvider>
              <CartProvider>
                <NostoProvider>
                  <MenuProvider>
                    <AppWrapper node={node}>{children}</AppWrapper>
                  </MenuProvider>
                </NostoProvider>
              </CartProvider>
            </WishlistProvider>
          </NoticesProvider>
        </LayoutProvider>
      </GlobalProvider>
    </ReCaptchaProvider>
  );
};

SportscraftAppWrapper.propTypes = {
  children: PropTypes.node,
};

SportscraftAppWrapper.displayName = 'SportscraftAppWrapper';

export default compose(
  connect((globalState) => {
    return {
      renderContext: globalState.renderContext,
      node: globalState.node,
      context: globalState.app?.context,
      appState: globalState.app,
    };
  }),
)(SportscraftAppWrapper);
